import axios from "axios";
import { getUnitApiBaseFour, SUB_URL } from "./BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const EOLService = {
  getKanbanDataById: async (kanbanId) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("kb_number", kanbanId?.kb_number || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_kanban_data}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Kanban Data Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching Kanban data:", error);
      return [];
    }
  },

  add_eol_dispatch: async (
    size,
    userData,
    dispatchArea,
    editValue,
    selectedBin,
    binFull,selectedLine
  ) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("kanban_no", editValue?.[0]?.kanban_no || "");
      formData.append("dispatch_area", dispatchArea || "");
      formData.append("added_by", userData?.su_id || "");
      formData.append("size_name", size || "");
      formData.append("bin_id", selectedBin || "");
      formData.append("bin_full", binFull || "no");
      if (selectedLine) {
                formData.append('bin_line', selectedLine);
            }


      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.add_eol_dispatch}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Add EOL Dispatch Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error adding EOL dispatch:", error);
      return [];
    }
  },

  getLines: async () => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.get(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.getLine}`
      );

      console.log("Line Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching lines:", error);
      return [];
    }
  },

  getAvailableBins: async () => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.get(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_available_bins}`
      );

      console.log("Available Bins Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching bins:", error);
      return [];
    }
  },
};

export default EOLService;